import Dexie, { type EntityTable } from "dexie";

import type { JobKind } from "@aion/core";

export type OutboxStatus =
  | "ready"
  | "uploading"
  | "queued"
  | "failed";

export interface OutboxItem {
  id: string;
  kind: JobKind;
  inputKind: "audio" | "text" | "url";
  blob?: Blob;
  mimeType?: string;
  sourceText?: string;
  sourceUrl?: string;
  route: "/c" | "/q";
  createdAt: number;
  updatedAt: number;
  status: OutboxStatus;
  attempts: number;
  errorMessage?: string;
}

class AionOutboxDatabase extends Dexie {
  items!: EntityTable<OutboxItem, "id">;

  constructor() {
    super("aion-outbox");
    this.version(1).stores({
      items: "id, status, kind, inputKind, createdAt, updatedAt",
    });
  }
}

export const outbox = new AionOutboxDatabase();

export const createOutboxId = (): string =>
  `${crypto.randomUUID()}-${Date.now().toString(36)}`;

export const saveAudioToOutbox = async ({
  blob,
  kind,
  route,
}: {
  blob: Blob;
  kind: JobKind;
  route: "/c" | "/q";
}): Promise<OutboxItem> => {
  const now = Date.now();
  const item: OutboxItem = {
    id: createOutboxId(),
    kind,
    inputKind: "audio",
    blob,
    mimeType: blob.type || "audio/webm",
    route,
    createdAt: now,
    updatedAt: now,
    status: "ready",
    attempts: 0,
  };

  await outbox.items.add(item);
  return item;
};

export const saveTextToOutbox = async ({
  kind,
  route,
  sourceText,
}: {
  kind: JobKind;
  route: "/c" | "/q";
  sourceText: string;
}): Promise<OutboxItem> => {
  const now = Date.now();
  const item: OutboxItem = {
    id: createOutboxId(),
    kind,
    inputKind: "text",
    sourceText,
    route,
    createdAt: now,
    updatedAt: now,
    status: "ready",
    attempts: 0,
  };

  await outbox.items.add(item);
  return item;
};

